<!-- 上传视频附件 -->
<template>
    <div class>
      
      <div class="box" style="position:relative;flex-wrap: wrap;">
        <div
          v-if="isShowAdd || isActive"
          style="position:relative;"
          :class="isActive?'isActive':''"
          :style="{marginTop:isActive?'-'+ activeHeight+'px':'',width:width100?'100%':''}"
        >
          
          <input
            type="file"
            id="uploads"
            style="position: absolute;opacity:0;right: 0px;top:0;height: 100%;"
            :style="{width:imgInputWidth}"
            accept=".pdf"
            @change.stop:="uploadImg"
            ref="videos"
          />
        </div>
      </div>
 
    </div>
  </template>
  
  <script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import photoCut from "./photoCut.vue";
  import previewImg from "./previewImg.vue";
  export default {
     name: "uploadImg",
    //import引入的组件需要注入到对象中才能使用
    components: {
      photoCut,
      previewImg
    },
    props: {
      nocaijian: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ""
      },
      imgArr: Array,
      imgNumber: {
        type: Number,
        default: 0
      },
      imgWidth: {
        default: 100,
        type: Number
      },
      isActive: {
        default: false,
        type: Boolean
      },
      imgHeight: {
        default: 50,
        type: Number
      },
      imgInputWidth: {
        default: "100%",
        type: String
      },
      /* 是否触发 */
      isClick: {
        default: 0,
        type: Number
      },
      /* 是否是编辑器 */
      isEditorBox: {
        default: false,
        type: Boolean
      },
      /* 点击对象e */
      isClickE: null,
      fixedNumber: {
        type: Array,
        default: function() {
          return [2, 1];
        }
      },
      width100: {
        type: Boolean,
        default: false
      }
    },
    //监听属性 类似于data概念
    computed: {
      isShowAdd() {
        return this.imgNumber && this.imgArr.length < this.imgNumber;
      },
      activeHeight() {
        return this.imgHeight + 20;
      },
      isShowAdd() {
        return this.imgNumber && this.imgArr.length < this.imgNumber;
      }
    },
    data() {
      //这里存放数据
      return {
        modals:false,
        previewMode: false, //是否预览
        currentIndex: 0, //从第几张开始预览
        spinShow: false,
        modal: false,
        filename: "", //存储选上传时择文件的文件名
        option: {
          img: ""
        },
        newArr: []
      };
    },
    //监控data中的数据变化
    watch: {
      isClick() {
        this.uploadImg(this.isClickE);
      }
    },
    //方法集合
    methods: {
      uploadImg(e) {
        e.stopPropagation()
        if (!e || Object.keys(e).length === 0) return;
        console.log('------shangchuan-----')
        var file = e.target.files[0]; // 只支持选择一个文件
        this.filename = file.name;
        if (!/\.(pdf)$/.test(e.target.value)) {
          this.$Notice.warning({
            title: "附件类型必须是.pdf"
          });
          return false;
        }
        var File = e.target.files[0];
        console.log(File)
        this.$post(this.urlobj.uploadFile, File)
          .then(res => {
            console.log(res)
            // this.$store.commit("updateSpinShow", false);
            // let img_obj = {
            //   path: res.rows[0].defaulturl, // 文件路径
            //   id: res.rows[0].id // 图片的id
            // };
            // // this.imgArr.push(img_obj);
            // this.spinShow = false;
            // this.$Message.success("上传成功");
            // var fileObj = document.getElementById("uploads").files[0];
            // this.$emit("savePic", fileObj);
            // this.$emit("saveImg", img_obj);
            // // this.saveImage(res.rows[0].id)
          })
          .catch(error => {
            this.spinShow = false;
          });
        // if(file.size/1024>2048){
        //     this.$Notice.warning({
        //         title: '文件大小超出限制'
        //     });
        //     return
        // }
        // var reader = new FileReader();
        // reader.onload = e => {
        //   this.option.img = e.target.result;
        //   if(this.nocaijian){
        //     this.modals = true;
        //   }else{
        //     this.modal = true;
        //   }
        //   // 在外部触发 uploadImg 时 refs.imgs不存在
        //   if (this.$refs.imgs) {
        //     this.$refs.imgs.value = "";
        //   }
        // };
        // reader.readAsDataURL(file);
         
      },
      previewImg(index) {
        this.previewMode = !this.previewMode;
        this.currentIndex = index;
        var img1 = this.imgArr.slice(0, index);
        var img2 = this.imgArr.slice(index);
        this.newArr = img2.concat(img1);
      },
      closePreview() {
        console.log("parent-closePreview");
        this.previewMode = false;
      },
      deleteImg(e, index) {
        e.stopPropagation();
        let communityEntity = {
          id: this.imgArr[index].id,
          index: index
        };
        this.$emit("delPic", communityEntity);
      },
      finishend(data) {
        /**图片存到服务器 */
        console.log("------------走到这里---------");
        // this.$store.commit("updateSpinShow", true);
        this.spinShow = true;
        let p = {
          source: "materialPicture",
          filename: this.filename,
          communityid: this.$store.state.streetorcommunityid,
          communitytype: this.$store.state.streetorcommunity
        };
        p.base64img = data;
        this.$post(this.urlobj.uploadImg, this.qs.stringify(p))
          .then(res => {
            // this.$store.commit("updateSpinShow", false);
            let img_obj = {
              path: res.rows[0].defaulturl, // 文件路径
              id: res.rows[0].id // 图片的id
            };
            // this.imgArr.push(img_obj);
            this.spinShow = false;
            this.$Message.success("上传成功");
            var fileObj = document.getElementById("uploads").files[0];
            this.$emit("savePic", fileObj);
            this.$emit("saveImg", img_obj);
            // this.saveImage(res.rows[0].id)
          })
          .catch(error => {
            this.spinShow = false;
          });
      },
      caijian() {
        if(this.nocaijian){
          console.log("-------nocaijian---------");
          this.finishend(this.option.img)
        }else{
          console.log("-------caijian---------");
          this.$refs.photocaijian.finish("base64");
        }
      },
      quxiao() {
        console.log("-------quxiao---------");
        this.$refs.imgs.value = "";
        this.modal1 = false;
        this.$emit("cancelUpload");
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      console.log(this.nocaijian)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>
  <style lang='less' scoped>
  //@import url(); 引入公共css类
  .label {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  
  .imgbox {
    position: relative;
    margin-right: 30px;
    margin-bottom: 20px;
    box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.1);
  }
  
  .img_item {
    // margin-top: 10px;
  }
  .img_delete {
    position: absolute;
    top: -10px;
    right: -10px;
    height: 20px;
    width: 20px;
  }
  
  .size {
    font-size: 14px;
    color: #999;
    margin: 20px 0 85px 0;
  }
  
  .isActive {
    opacity: 0;
  }
  #uploads {
    width: 100%;
  }
  </style>
  